'use client';

import React from 'react';
import util from 'util';
import { useTranslations } from 'next-intl';
import DetailsTile from '@/ui/components/shared/DetailsTile';
import DetailsTileHeading from '@/ui/components/shared/DetailsTileHeading';
import OrderAddress from '@/ui/components/shared/order-details/OrderAddress/OrderAddress';
import AccountOrderSummary from '@/ui/components/shared/AccountOrderSummary';
import { WithdrawalConfirmData } from '@/server-functions/withdrawal/withdrawal-types';

type OrderData = Extract<WithdrawalConfirmData, { status: 'ok' }>;

// Read-only order summary and addresses, rendered with the My Account order page components.
export function WithdrawalOrderOverview({ order }: Readonly<{ order: OrderData }>) {
  const t = useTranslations('OrderDetails');
  const title = util.format(t('Order #%s summary'), order.reference);

  return (
    <div className="space-y-6">
      <DetailsTile className="p-0 sm:p-0">
        <DetailsTileHeading heading={title} className="p-4 sm:p-6" />
        <AccountOrderSummary
          cartItems={{ products: order.parsedProducts, bundles: [] }}
          costBreakdown={order.costBreakdown}
          currency={order.currency}
          pricingMode={order.pricingMode}
          textSize="large"
        />
      </DetailsTile>
      <DetailsTile>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div>
            <DetailsTileHeading heading={t('Shipping address')} />
            <OrderAddress {...order.deliveryAddress} />
          </div>
          <div>
            <DetailsTileHeading heading={t('Billing address')} />
            <OrderAddress {...order.billingAddress} />
          </div>
        </div>
      </DetailsTile>
    </div>
  );
}
